import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Statuses, Task} from '../../../entities/Task';
import {AppFile} from '../../../entities/AppFile';
import {FileService} from '../../../services/file.service';
import {Observable} from 'rxjs';
import {IMyDpOptions, IMyDateModel} from 'mydatepicker';
import {environment} from '../../../../environments/environment';
import {Responsible} from '../../../entities/SalesPerson';
import * as moment from 'moment';
import {TaskService} from '../../../services/task.service';
import {CommunicationLog} from '../../../entities/CommunicationLog';
import {escape} from 'querystring';

@Component({
  selector: 'app-modal-lite-task',
  templateUrl: './modal-lite-task.component.html',
  styleUrls: ['./modal-lite-task.component.css']
})
export class ModalLiteTaskComponent implements OnInit {


  inputCommunicationLog: string;
  _communicationLogs: CommunicationLog[] = [];
  _chosenTask: Task = new Task();
  _salesPersons: Responsible[] = [];
  _salesPerson: Responsible = new Responsible();
  _status: Statuses;
  status: string;

  @Input('FilesToDownload')
  set FilesToDownload(files: AppFile[]) {
    this.filesToDownload = files;
  }

  @Input('DoneLoading')
  set DoneLoading(loading: boolean) {
    this.doneLoading = loading;
  }

  @Input('Loading')
  set Loading(value: boolean) {
    this.loading = value;
  }

  @Input('chosenTask')
  set chosenTask(task: any) {
    if (task != null) {
      this._chosenTask = Object.assign(this._chosenTask, task);
      this.InitDatapickers();
      this.getFiles(task);
    }
  }

  @Input('CommunicationLogs')
  set CommunicationLogs(value: CommunicationLog[]) {
    this._communicationLogs = value;
  }

  @Input('salesPersons')
  set salesPersons(salesPersons: any) {
    if (salesPersons != null) {
      this._salesPersons = Object.assign(this._salesPersons, salesPersons);
    }
    this._salesPerson.Code = this._chosenTask.Responsible;
  }


//  @Input('communicationLogs')
//  set communicationLogs(communicationLogs: any){
//    if(communicationLogs != null){
//      this._communicationLogs = Object.assign(this._communicationLogs, communicationLogs);
//    }
//  }


  filesToDownload: AppFile[] = [];
  @Output()
  removeFileEmitter = new EventEmitter();
  @Output()
  uploadFilesEmitter = new EventEmitter();
  @Output()
  downloadFileEmitter = new EventEmitter();
  @Output()
  updateTaskEmitter = new EventEmitter();
  @Output()
  createCommunicationLogEmitter = new EventEmitter();
  @Output()
  uploadFileEmitter = new EventEmitter();
  @Output()
  closingModalEmitter = new EventEmitter();


  filesToUpload: AppFile[] = [];

  currentFile: AppFile;

  doneLoading: boolean;
  loading: boolean;

  @ViewChild('myInput')
  fileChooserValue: ElementRef;

  dummyStart: any;
  dummyEnd: any;
  dummyDeadline: any;


  public startDatePickerOptions: IMyDpOptions;

  public endDatePickerOptions: IMyDpOptions;

  public deadlineOptions: IMyDpOptions;

  statuses = Statuses;
  keys: any;

  constructor(private fileService: FileService) {
  }

  ngOnInit() {
    window.addEventListener('keydown', (ev) => {
      if (ev.which == 27) {
        $('#closeBtn').click();
        this.closeModal();
      }
    });
    this.currentFile = new AppFile();

    this.keys = Object.keys(this.statuses).filter(k => !isNaN(Number(k)));
  }

  InitDatapickers() {
    //this._chosenTask.end = moment(new Date(this._chosenTask.end).setDate(new Date(this._chosenTask.end).getDate())).format(environment.START_DATETIME_FORMAT);
    //moment(new Date(calEvent.end).setDate(new Date(calEvent.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)

    this._chosenTask.Deadline = moment(new Date(this._chosenTask.Deadline).setDate(new Date(this._chosenTask.Deadline).getDate())).format(environment.START_DATETIME_FORMAT);

    //moment().format(environment.START_DATETIME_FORMAT); //TODAY
    this.dummyStart = {
      date: {
        year: new Date(this._chosenTask.start).getFullYear(),
        month: new Date(this._chosenTask.start).getMonth() + 1,
        day: new Date(this._chosenTask.start).getDate()
      }
    };


    this.dummyEnd = {
      date: {
        year: new Date(this._chosenTask.end).getFullYear(),
        month: new Date(this._chosenTask.end).getMonth() + 1,
        day: new Date(this._chosenTask.end).getDate()
      }
    };

    this.dummyDeadline = {
      date: {
        year: new Date(this._chosenTask.Deadline).getFullYear(),
        month: new Date(this._chosenTask.Deadline).getMonth() + 1,
        day: new Date(this._chosenTask.Deadline).getDate()
      }
    };
    this.setOptionsData();
    this.InitElementsForView();
  }

  updateTask(chosenTask) {
    this.closeModal();
    this.updateTaskEmitter.emit(chosenTask);
  }


  getFiles(task: Task) {
    if (task.Task_GUID != null) {
      this.fileService.getFilesByKey(task.Task_GUID, 'App Task').subscribe(files => this.filesToDownload = files);
    }
  }


  setOptionsData() {
    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: {
          year: new Date(this._chosenTask.end).getFullYear(),
          month: new Date(this._chosenTask.end).getMonth() + 1,
          day: new Date(this._chosenTask.end).getDate() + 1
        }, end: {year: 2055, month: 11, day: 20}
      }],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: {year: 1980, month: 11, day: 20},
        end: {
          year: new Date(this._chosenTask.start).getFullYear(),
          month: new Date(this._chosenTask.start).getMonth() + 1,
          day: new Date(this._chosenTask.start).getDate() - 1
        }
      }],
    };
    this.deadlineOptions = {
      dateFormat: 'dd-mm-yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      //disableDateRanges: [{begin: {year: new Date(this._chosenTask.Deadline).getFullYear(), month: new Date(this._chosenTask.Deadline).getMonth() + 1, day: new Date(this._chosenTask.Deadline).getDate() + 1}, end: {year: 2055, month: 11, day: 20}}],
    }
  }

  setStartDate(event: IMyDateModel) {
    this._chosenTask.start = event.jsdate.toDateString();

    this.setOptionsData();
  }

  setEndDate(event: IMyDateModel) {
    this._chosenTask.end = event.jsdate.toDateString();

    this.setOptionsData();
  }

  setDeadline(event: IMyDateModel) {
    this._chosenTask.Deadline = event.jsdate.toDateString();

    this.setOptionsData();
  }

  createCommunicationLog(note: string) {
    this.createCommunicationLogEmitter.emit(note);
  }

  uploadFiles() {
    this.uploadFilesEmitter.emit(this.filesToUpload);
  }

  downloadFile(file) {
    this.downloadFileEmitter.emit(file);
  }

  InitElementsForView() {
    let text_html = document.getElementById('Text');
    let work_description_html = document.getElementById('Work_Description');
    let estimat_html = document.getElementById('Estimat');
    let responsible_html = document.getElementById('Responsible');
    let to_be_done_by_html = document.getElementById('To_Be_Done_By');
    let status_html = document.getElementById('Status');


    this.checkForEmpty(this._chosenTask.Text, text_html);
    this.checkForEmpty(this._chosenTask.Work_Description, work_description_html);
    this.checkForEmpty(this._chosenTask.Estimate.toString(), estimat_html);
    this.checkForEmpty(this._chosenTask.Responsible, responsible_html);
    this.checkForEmpty(this._chosenTask.To_Be_Done_By, to_be_done_by_html);
    this.checkForEmpty(this._chosenTask.Status, status_html);
  }

  checkForEmpty(input: string, htmlElement: HTMLElement) {
    htmlElement;

    if (htmlElement.id == 'Estimat') {
      if (input == '0') {
        htmlElement.style.cssText = 'border-bottom: 2px solid red; text-align: right';
      } else {
        htmlElement.style.cssText = 'border-bottom: 1px solid #ccc; text-align: right';
      }
    } else if (htmlElement.id == 'Work_Description') {
      if (input == '') {
        htmlElement.style.cssText = 'border-bottom: 2px solid red; text-align: left';
      } else {
        htmlElement.style.cssText = 'border-bottom: 1px solid #ccc; text-align: left';
      }
    } else if (input != null && htmlElement != null) {
      if (input == '') {
        htmlElement.style.cssText = 'border-bottom: 2px solid red; text-align: right';
      } else {
        if (htmlElement.nodeName == 'SELECT') {
          htmlElement.style.cssText = 'color: #555; text-align: right';
        } else {
          htmlElement.style.cssText = 'border-bottom: 1px solid #ccc; text-align: right';
        }
      }
    }
  }

  uploadFileTemp(file: AppFile) {
    file.Key = this._chosenTask.Task_GUID;
    this.filesToUpload.push(file);
  }

  closeModal() {
    this.closingModalEmitter.emit();
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-lite-task/modal-lite-task.component.ts